import React, { ReactNode } from 'react';

import { IconDoneCircle2, IconErrorCircle } from '@trqk/components';

import { CallToAction } from './CallToAction';

interface DataStatusProps {
    callToActionConfig: SetUpGapAnalysisCallToActionConfig;
    children: ReactNode;
    dataTitle: string;
    hasData: boolean;
    missingLabel: ReactNode;
    showCallToAction: boolean;
}

export const DataStatus = ({
    callToActionConfig,
    children,
    dataTitle,
    hasData,
    missingLabel,
    showCallToAction,
}: DataStatusProps): JSX.Element => (
    <div className="rounded-lg p-6 border border-tertiary-200 shadow-lg">
        <div
            className="grid items-baseline"
            style={{ gridTemplateColumns: '180px auto 40px' }}
        >
            <h4 className="text-lg">{dataTitle}</h4>
            <div>
                {hasData && <>{children}</>}
                {!hasData && missingLabel}
            </div>
            {hasData && (
                <IconDoneCircle2
                    addClasses="place-self-center justify-self-end"
                    fillColor="primary-500"
                    width={30}
                />
            )}
            {!hasData && (
                <IconErrorCircle
                    addClasses="place-self-center justify-self-end"
                    fillColor="quinary-500"
                    width={30}
                />
            )}
        </div>
        {showCallToAction && <CallToAction config={callToActionConfig} />}
    </div>
);
